import R from "ramda";
import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import empresa from "../app/Empresas/vuex";
import usuario from "../app/Usuarios/vuex";
import funrural from "../app/Funrural/vuex";
import ncm from "../app/Ncm/vuex";
import queue from "../components/TheQueue/vuex";
import contabilista from "../app/Contabilistas/vuex";
import auditoriaCfop from "../app/AuditoriaSpedFiscal/NewAuditoriaCfop/vuex";
import apuracaoIcmsSt from "../app/AuditoriaSpedFiscal/ApuraçãoIcmsSt/vuex";
import estimativa from "../app/ApuracaoICMS/Esimativa/vuex";
import referenciacaoPauta from "../app/RICMS/ReferenciacaoPauta/vuex";
import nfse from "../app/Nfse/vuex";
import diferencialDeAliquota from "../app/AuditoriaSpedFiscal/DiferencialDeAliquota/vuex";

Vue.use(Vuex);

let loggedUser = {};
let selectedCompany = JSON.parse(
  window.sessionStorage.getItem("selectedCompany"),
);
let token = window.sessionStorage.getItem("token");
let notifications = JSON.parse(window.sessionStorage.getItem("notifications"));

if (R.isNil(loggedUser)) {
  loggedUser = {};
}

if (R.isNil(selectedCompany)) {
  selectedCompany = {};
}

if (R.isNil(notifications)) {
  notifications = [];
}

const state = {
  user: loggedUser,
  company: selectedCompany,
  isMenuToggled: true,
  token,
  notifications: notifications,
};

const mutations = {
  GET_USER(state) {
    return state.user;
  },

  SET_USER(state, user) {
    loggedUser = user;
    state.user = user;
    // if (user.id) {
    //   const params = { query: { userId: user.id, user: user.nome } }
    //   Vue.prototype.$socket.io.opts.query = params.query
    //   Vue.prototype.$socket.connect(params)
    // } else {
    //   Vue.prototype.$socket.disconnect()
    // }
  },

  GET_COMPANY(state) {
    return state.company;
  },

  SET_COMPANY(state, company) {
    selectedCompany = window.sessionStorage.setItem(
      "selectedCompany",
      JSON.stringify(company),
    );
    state.company = company;
  },

  GET_MENU(state) {
    return state.isMenuToggled;
  },

  SET_MENU(state, isMenuToggled) {
    state.isMenuToggled = isMenuToggled;
  },

  GET_TOKEN(state) {
    return state.token;
  },

  SET_TOKEN(state, token) {
    window.sessionStorage.setItem("token", token);
    state.token = token;
    router.push({ name: "Main" });
  },

  REFRESH_TOKEN(state, token) {
    window.sessionStorage.setItem("token", token);
    state.token = token;
  },

  GET_NOTIFICATIONS(state) {
    return state.notifications;
  },

  SET_NOTIFICATIONS(state, notification) {
    state.notifications = state.notifications.concat([notification]);
    window.sessionStorage.setItem(
      "notifications",
      JSON.stringify(state.notifications),
    );
  },

  CLEAR_NOTIFICATIONS(state) {
    state.notifications = [];
    window.sessionStorage.setItem(
      "notifications",
      JSON.stringify(state.notifications),
    );
  },

  REMOVE_NOTIFICATION(state, notification) {
    let index = state.notifications.indexOf(notification);
    state.notifications = state.notifications.filter((x, idx) => idx !== index);
    window.sessionStorage.setItem(
      "notifications",
      JSON.stringify(state.notifications),
    );
  },
};

const actions = {
  getUser({ commit }) {
    commit("GET_USER");
  },

  setUser({ commit }, user) {
    commit("SET_USER", user);
  },

  getCompany({ commit }) {
    commit("GET_COMPANY");
  },

  setCompany({ commit }, company) {
    commit("SET_COMPANY", company);
  },

  getMenu({ commit }) {
    commit("GET_MENU");
  },

  setMenu({ commit }, isMenuToggled) {
    commit("SET_MENU", isMenuToggled);
  },

  getToken({ commit }) {
    commit("GET_TOKEN");
  },

  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },

  refreshToken({ commit }, token) {
    commit("REFRESH_TOKEN", token);
  },

  getNotifications({ commit }) {
    commit("GET_NOTIFICATIONS");
  },

  setNotification({ commit }, notification) {
    commit("SET_NOTIFICATIONS", notification);
  },

  clearNotifications({ commit }) {
    commit("CLEAR_NOTIFICATIONS");
  },

  removeNotification({ commit }, notification) {
    commit("REMOVE_NOTIFICATION", notification);
  },
};

const getters = {
  getUser: (state) => state.user,
  getCompany: (state) => state.company,
  getMenu: (state) => state.isMenuToggled,
  getToken: (state) => state.token,
  getNotifications: (state) => state.notifications,
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    contabilista,
    auditoriaCfop,
    apuracaoIcmsSt,
    ncm,
    queue,
    empresa,
    usuario,
    funrural,
    estimativa,
    referenciacaoPauta,
    nfse,
    diferencialDeAliquota,
  },
});
